module.exports = __webpack_public_path__ + "static/media/phone@3x.a20f099f.png";